import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'signin-previously_logged_in-action_unknown';

/**
 * Event triggered whenever a visitor lands on the logged out home page. The first param is a flag indicating whether the user is a retailer that has previously logged out.
 */
export function trackSigninPreviouslyLoggedIn(
  Previously_logged_in: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { Previously_logged_in },
  });
}
